export default __webpack_public_path__ + "assets/0c6a70c892fe942a6d2471fb17c593a5.png";